import React from 'react';
export function TablePageShimmer() {
  return <div className="space-y-6 animate-pulse" role="status" aria-busy="true" aria-live="polite" data-id="element-15431" data-mp="2ipzhdnzzog8b">
      <span className="sr-only" data-id="element-15432" data-mp="l59dyeo7rxwh">Loading table…</span>
      {/* Header with button */}
      <div className="flex justify-between items-center" data-id="element-15433" data-mp="l3g7azdlpdoh">
        <div className="h-6 w-48 bg-gray-200 rounded" data-id="element-15434" data-mp="q316nawono1q" />
        <div className="h-10 w-32 bg-gray-200 rounded-md" data-id="element-15435" data-mp="3olzmp1b6kp1v" />
      </div>
      {/* Stats cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-15436" data-mp="3tl2li40khz1e">
        {[1, 2, 3, 4].map(i => <div key={i} className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-15437" data-mp="2erm0cb7h6c6">
            <div className="h-4 w-24 bg-gray-200 rounded mb-2" data-id="element-15438" data-mp="75zvt9gg6tpv" />
            <div className="h-8 w-32 bg-gray-200 rounded mb-2" data-id="element-15439" data-mp="77b3vlgxenms" />
            <div className="h-3 w-20 bg-gray-200 rounded" data-id="element-15440" data-mp="35uyssrox3jp6" />
          </div>)}
      </div>
      {/* Table */}
      <div className="bg-white rounded-lg border border-gray-200" data-id="element-15441" data-mp="3asqm9q57ndvh">
        {/* Table header */}
        <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-15442" data-mp="15ot8haxmqos9">
          <div className="h-4 w-32 bg-gray-200 rounded" data-id="element-15443" data-mp="10r1i4lcmvaq6" />
          <div className="h-10 w-64 bg-gray-200 rounded-md" data-id="element-15444" data-mp="vz9o20u9qmva" />
        </div>
        {/* Table content */}
        <div className="overflow-x-auto" data-id="element-15445" data-mp="ryzksvxv2ak4">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-15446" data-mp="rxxy1u7hfzmk">
            <thead data-id="element-15447" data-mp="n04r2yycv1l8">
              <tr data-id="element-15448" data-mp="n0o9egrx3rzs">
                {[1, 2, 3, 4, 5].map(i => <th key={i} className="px-4 py-3" data-id="element-15449" data-mp="hzqt69qgx80x">
                    <div className="h-3 w-20 bg-gray-200 rounded" data-id="element-15450" data-mp="i2378bt3uy8p" />
                  </th>)}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-15451" data-mp="903sxr9h689g">
              {[1, 2, 3, 4, 5, 6, 7, 8].map(i => <tr key={i} data-id="element-15452" data-mp="27dwy0i6y4pbq">
                  {[1, 2, 3, 4, 5].map(j => <td key={j} className="px-4 py-4" data-id="element-15453" data-mp="23d3dlysppsnl">
                      <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-15454" data-mp="23b8p6ai8fier" />
                    </td>)}
                </tr>)}
            </tbody>
          </table>
        </div>
        {/* Pagination */}
        <div className="p-4 border-t border-gray-200 flex justify-between items-center" data-id="element-15455" data-mp="3nvnp3lmq61y5">
          <div className="h-4 w-32 bg-gray-200 rounded" data-id="element-15456" data-mp="3rwz5d0jplato" />
          <div className="flex gap-2" data-id="element-15457" data-mp="3rxilqctpnr5l">
            {[1, 2, 3, 4].map(i => <div key={i} className="h-8 w-8 bg-gray-200 rounded" data-id="element-15458" data-mp="ji8q9nkbtk6s" />)}
          </div>
        </div>
      </div>
    </div>;
}